(() => {
  const init = (section) => {
    if (section.dataset.mpFeatureTabsReady === 'true') return;
    section.dataset.mpFeatureTabsReady = 'true';

    const tabs = [...section.querySelectorAll('[data-mp-feature-tab]')];
    const panels = [...section.querySelectorAll('[data-mp-feature-panel]')];
    const copies = [...section.querySelectorAll('[data-mp-feature-copy]')];
    let active = 0;

    const select = (index, focus = false) => {
      active = (index + tabs.length) % tabs.length;
      tabs.forEach((tab, i) => {
        const selected = i === active;
        tab.classList.toggle('is-active', selected);
        tab.setAttribute('aria-selected', String(selected));
        tab.tabIndex = selected ? 0 : -1;
      });
      panels.forEach((panel, i) => {
        const selected = i === active;
        panel.hidden = !selected;
        panel.classList.toggle('is-active', selected);
      });
      copies.forEach((copy, i) => {
        const selected = i === active;
        copy.hidden = !selected;
        copy.classList.toggle('is-active', selected);
      });
      tabs[active].scrollIntoView({ behavior: 'smooth', block: 'nearest', inline: 'center' });
      if (focus) tabs[active].focus({ preventScroll: true });
    };

    tabs.forEach((tab, i) => {
      tab.addEventListener('click', () => select(i));
      tab.addEventListener('keydown', (event) => {
        if (event.key === 'ArrowRight') { event.preventDefault(); select(i + 1, true); }
        if (event.key === 'ArrowLeft') { event.preventDefault(); select(i - 1, true); }
      });
    });
    section.querySelector('[data-mp-feature-prev]')?.addEventListener('click', () => select(active - 1));
    section.querySelector('[data-mp-feature-next]')?.addEventListener('click', () => select(active + 1));
  };

  const boot = (root = document) => root.querySelectorAll('[data-mp-feature-tabs]').forEach(init);
  document.readyState === 'loading' ? document.addEventListener('DOMContentLoaded', () => boot()) : boot();
  document.addEventListener('shopify:section:load', (event) => boot(event.target));
})();
